import {isEmpty, map, some, sortBy} from 'lodash';
import React, {useCallback, useEffect} from 'react';
import classNames from 'classnames';
import {useDispatch, useSelector} from 'react-redux';

import {newMultimedia, editMultimedia} from 'shared/portfolio/actions/multimedia';
import {Store} from 'src/types/store';
import {useMediaQuery} from 'src/hooks/useMediaQuery';
import TwoColumnMasonry from 'shared/portfolio/components/two-column-masonry';
import MediaCard from '../media-card';
import MultimediaForm from './multimedia-form';
import Multimedia from './multimedia';
import Section from '../section';
import PortfolioSectionHeader from '../portfolio-section-header';
import EmptyPlaceholder from '../empty-placeholder';
import PortfolioIcon from '../portfolio-icon/portfolio-icon';

const Raise = window.Raise;

const MultimediaItems = () => {
  const mq = useMediaQuery();
  const dispatch = useDispatch();
  const multimedia = useSelector((state: Store) => state.multimedia);
  const editing = some(multimedia, 'editing');
  const handleAddClick = useCallback(() => dispatch(newMultimedia({scrollTo: true})), [dispatch]);

  useEffect(() => {
    Raise.vent.on('add:multimedia', handleAddClick);
  }, [handleAddClick]);

  let multimediaItems: React.ReactNode = null;

  if (isEmpty(multimedia)) {
    multimediaItems = (
      <div className="portfolio-sections column">
        <EmptyPlaceholder
          onClick={handleAddClick}
          header="Add a Project"
          description="Up to $500 per Project"
          portfolioItemType="multimedia"
        />
      </div>
    );
  } else {
    const sorted = sortBy(multimedia, (element) => {
      if (element.new) {
        return -Number.MAX_SAFE_INTEGER;
      }

      return (element.year * 100 + element.month) * -1;
    });

    multimediaItems = (
      <TwoColumnMasonry>
        {map(sorted, (sortedMultimedia) => {
          if (sortedMultimedia.editing) {
            return (
              <div
                className={classNames('portfolio-sections column', {
                  editing: sortedMultimedia.editing,
                })}
                key={sortedMultimedia._id}
              >
                <MultimediaForm multimedia={sortedMultimedia} />
              </div>
            );
          } else {
            return (
              <div className="portfolio-sections column" key={sortedMultimedia._id}>
                <MediaCard
                  id={sortedMultimedia._id}
                  active={!!sortedMultimedia.scrollTo}
                  onClick={() => {
                    dispatch(editMultimedia(sortedMultimedia));
                  }}
                >
                  <Multimedia
                    _id={sortedMultimedia._id}
                    title={sortedMultimedia.title}
                    category={sortedMultimedia.category}
                    previewUrls={sortedMultimedia.previewUrls}
                    scrollTo={sortedMultimedia.scrollTo}
                    year={sortedMultimedia.year}
                    month={sortedMultimedia.month}
                  />
                </MediaCard>
              </div>
            );
          }
        })}
      </TwoColumnMasonry>
    );
  }

  return (
    <div>
      <PortfolioSectionHeader
        title="Art and Media"
        displayNew={!editing && !(mq.XS && !Object.keys(multimedia).length)}
        addNew={handleAddClick}
        sectionName="multimedia"
      >
        <PortfolioIcon type="multimedia" size={mq.XS ? 40 : 56} />
      </PortfolioSectionHeader>
      <Section>
        <div id="multimedia" className="portfolio-sections main-section"></div>
        {multimediaItems}
      </Section>
    </div>
  );
};

export default MultimediaItems;
